/**
 * A warm-up ramp as typed and shown: the most emails a day on day 1, 2,
 * 3..., the last figure holding from then on. Figures are separated by
 * commas or spaces: "200, 500, 1000" reads as [200, 500, 1000].
 */
export const GENTLE_RAMP = [200, 500, 1000, 2000, 5000, 10000];

export function parseRamp(text: string): number[] {
  return text
    .split(/[\s,;]+/)
    .map((t) => Number(t))
    .filter((n) => Number.isFinite(n) && n > 0)
    .map((n) => Math.floor(n))
    .slice(0, 60);
}

export function showRamp(ramp: number[] | undefined | null): string {
  return (ramp ?? []).join(', ');
}

/** "200, then 500, then 1,000 a day from day 3 on". */
export function describeRamp(ramp: number[]): string {
  if (ramp.length === 0) return 'No warm-up.';
  const f = (n: number) => n.toLocaleString('en-GB');
  if (ramp.length === 1) return `Up to ${f(ramp[0] ?? 0)} a day.`;
  const head = ramp.slice(0, -1).map(f).join(', then ');
  return `${head}, then ${f(ramp[ramp.length - 1] ?? 0)} a day from day ${ramp.length} on.`;
}
